export default __webpack_public_path__ + "static/exp1-977eebcdc2048bca3b194c941476d1a1.jpg";